import { createSelector } from 'reselect';

const selectReviewsState = (state) => state.reviewsReducer || {};
const EMPTY_REVIEWS = [];

export const getReviews = () =>
  createSelector(selectReviewsState, (state) =>
    Array.isArray(state?.reviews) ? state.reviews : EMPTY_REVIEWS,
  );

export const getReviewsStats = () =>
  createSelector(selectReviewsState, (state) => state?.reviewsStats);
